<template>
  <ResizeObserver @resize="onResize">
    <div :class="classNames">
      <slot>
        <div :class="`${prefixCls}-icon-wrapper`">
          <slot name="icon">
            <lt-icon v-if="isHorizontal" :class="`${prefixCls}-icon`">
              <CaretBottom v-if="directionName === DIRECTION_BOTTOM" />
              <CaretTop v-if="directionName === DIRECTION_TOP" />
            </lt-icon>
            <lt-icon v-else :class="`${prefixCls}-icon`">
              <CaretRight v-if="directionName === DIRECTION_RIGHT" />
              <CaretLeft v-if="directionName === DIRECTION_LEFT" />
            </lt-icon>
          </slot>
        </div>
      </slot>
    </div>
  </ResizeObserver>
</template>
<script lang="ts" setup>
import { computed, toRefs } from 'vue'
import { LtIcon } from '@lit-element/components/icon'
import {
  CaretBottom,
  CaretLeft,
  CaretRight,
  CaretTop,
} from '@inte-cloud/icons-vue'
import ResizeObserver from './resize-observer'
import {
  DIRECTION_BOTTOM,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_TOP,
} from './data'
import type { PropType } from 'vue'

defineOptions({ name: 'LtResizeTrigger' })
const props = defineProps({
  prefixCls: {
    type: String,
    required: true,
  },
  direction: {
    type: String as PropType<'horizontal' | 'vertical'>,
    default: 'horizontal',
  },
  directionName: String,
})

const emits = defineEmits(['resize'])

const { direction, prefixCls } = toRefs(props)
const isHorizontal = computed(() => direction?.value === 'horizontal')
const classNames = computed(() => [
  prefixCls.value,
  {
    [`${prefixCls.value}-horizontal`]: isHorizontal.value,
    [`${prefixCls.value}-vertical`]: !isHorizontal.value,
  },
])
const onResize = (entry: ResizeObserverEntry) => {
  emits('resize', entry)
}
</script>
